import React, { useState } from "react";
import b11 from "../Assets/Images/b1-1.jpeg"
import b12 from "../Assets/Images/b1-2.jpeg"
import b13 from "../Assets/Images/b1-3.jpeg"
import b21 from "../Assets/Images/b2-1.jpeg"
import b22 from "../Assets/Images/b2-2.jpeg"
import b23 from "../Assets/Images/b1-3.jpeg"
import b31 from "../Assets/Images/b3-1.jpeg"
import b32 from "../Assets/Images/b3-2.jpeg"
import b33 from "../Assets/Images/b1-3.jpeg"
import f11 from "../Assets/Images/f1-1.jpeg"
import f12 from "../Assets/Images/f1-2.jpeg"
import f13 from "../Assets/Images/f1-1.jpeg"
import bd11 from "../Assets/Images/bd1-1.jpeg"
import bd12 from "../Assets/Images/bd1-2.jpeg"
import bd13 from "../Assets/Images/bd1-3.jpeg"


const memoriesData = [
  {
    title: "Team Trip to Nandigram",
    date: "March 2023",
    location: "Nandigram, Bhusawal",
    description:
      "A peaceful and refreshing team trip to Nandigram where we spent quality time together and strengthened our team bonding.",
    images: [b11, b12, b13],
  },
  {
    title: "Visit to Ajintha Caves",
    date: "July 2024",
    location: "Ajintha Caves, Ajintha",
    description:
      "An educational and memorable visit to the historic Ajintha Caves, exploring ancient art, architecture, and heritage.",
    images: [b22, b21],
  },
  {
    title: "Patna Devi Temple Visit",
    date: "December 2025",
    location: "Patna Devi",
    description:
      "A spiritual visit to Patna Devi where the team experienced peace, devotion, and togetherness.",
    images: [b32, b31],
  },
  {
    title: "Ashish Bendale Birthday Celebration",
    date: "April 2025",
    location: "Technoweit Office",
    description:
      "A warm and joyful birthday celebration of Ashish Bendale with the team, filled with smiles, gratitude, and togetherness.",
    images: [bd11, bd12, bd13],
  },
   {
  title: "Team Farewell Celebration",
  date: "May 2025",
  location: "Technoweit Office",
  description:
    "An emotional farewell celebration where we shared memories, expressed gratitude, and wished success for the next journey ahead.",
  images: [f11, f12, f13],
},
 
 

];


function Memories() {
  const [activeTrip, setActiveTrip] = useState(null);

  return (
    <>
      <div className="bg-Firefly py-10 md:py-20 pt-24 text-center">
        <h1 className="text-4xl font-bold text-white">Our Memories</h1>
        <p className="mt-3 text-gray-200">
          Moments that made our journey special
        </p>
      </div>

      <div className="bg-gray-100 py-10 md:py-20 px-8">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10 max-w-6xl mx-auto">
          {memoriesData.map((trip, index) => (
            <div
              key={index}
              className="bg-white rounded-xl shadow-md hover:shadow-xl transition overflow-hidden"
            >
              <img
                src={trip.images[0]}
                alt={trip.title}
                className="h-56 w-full object-cover"
              />

              <div className="p-6">
                <p className="text-sm text-gray-500">
                  {trip.date} • {trip.location}
                </p>
                <h3 className="mt-2 text-xl font-semibold text-gray-800">
                  {trip.title}
                </h3>
                <p className="mt-2 text-gray-600 text-sm">
                  {trip.description}
                </p>

                <button
                  onClick={() => setActiveTrip(trip)}
                  className="mt-4 inline-block rounded bg-black px-4 py-2 text-sm text-white"
                >
                  View Memories
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>

      {activeTrip && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/70 px-4">
          <div className="relative max-w-4xl w-full bg-white rounded-xl p-6">
            <button
              onClick={() => setActiveTrip(null)}
              className="absolute top-3 right-4 text-2xl font-bold text-gray-500 hover:text-black"
            >
              ×
            </button>

            <h2 className="text-2xl font-bold text-gray-800 mb-1">
              {activeTrip.title}
            </h2>
            <p className="text-sm text-gray-500 mb-4">
              {activeTrip.date} • {activeTrip.location}
            </p>

            <p className="text-gray-700 mb-6">
              {activeTrip.description}
            </p>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
              {activeTrip.images.map((img, idx) => (
                <img
                  key={idx}
                  src={img}
                  alt="memory"
                  className="h-48 w-full rounded-lg object-cover"
                />
              ))}
            </div>

            <div className="mt-6 text-right">
              <button
                onClick={() => setActiveTrip(null)}
                className="rounded bg-black px-6 py-2 text-white"
              >
                Close
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default Memories;
